import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { Col,
	Row,
	Button,
	Modal,
	Spin,
	message,
	Icon,
	Divider,
	DatePicker,
	Select } from 'antd';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { fetchContractDetail,
	newContract,
	deleteContract,
	addContract,
	changeContract,
	editContract,
	recoverContract,
	toggleEditContract } from '../../actions/employee-management-actions.js';

class ContractManagementDetail extends React.Component {
	state ={editingContract: {}}
	componentWillMount() {
		let employee_id = this.props.routing.location.pathname.split('/')[3];
		this.props.fetchContractDetail(employee_id);
	}
	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
	}
	newContract() {
		let newContract = {
      property_id: null,
      status_id: null,
      type_id: null,
      start_date: null,
      end_date: null,
      probation_end_date: null,
      is_active: null,
      unedit: false,
      unsave: true,
      new: true
		}
		this.props.newContract(newContract);
		setTimeout(() => {
			window.document.body.scrollTop = window.document.body.scrollHeight;
		});
	}
	addContract(index) {
		let currentContract = { ...this.props.employeeManagement.contractDetail[index]};
		currentContract.is_active = '当前合同' === currentContract.property_name;
		currentContract.unsave = false;
		console.log(currentContract);
		if (currentContract.id) {
			this.props.editContract(currentContract, index, (status, alertMessage) => {
				if (status) {
					message.success('修改合同成功', 4);
					this.props.toggleEditContract(index);
				}else{
					message.error('修改合同失败, ' + alertMessage, 4);
				}
			});
		}else{
			let newContract = {
				...currentContract,
				employee_id: this.props.employeeManagement.contractUserDetail.id,
				unsave: false
			}
			this.props.addContract(newContract, index, (status, alertMessage) => {
				if (status) {
					message.success('添加合同成功', 4);
				}else{
					message.error('添加合同失败, ' + alertMessage, 4);
				}
			});
		}
	}
	deleteContract(index) {
		Modal.confirm({
			title: '确定删除?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				let currentContract = this.props.employeeManagement.contractDetail[index];
				this.props.deleteContract(currentContract, index, state => {
					if (state) {
						message.success('删除合同成功', 4);							
					}else{
						message.error('删除合同失败', 4);
					}
				});
			},
			onCancel: () => {}
		});
	}
	changeContract(name, index, value) {
		let itemName = '';
		if (name && this.props.employeeManagement[name]) {
			this.props.employeeManagement[name].forEach(item => {
				if (item.Value === value) {
					itemName = item.Text;
					return;
				}
			});
		}else{
			if(value){
				value = value.format('YYYY-MM-DD');
			}
			
		}
		let changeItem = {
			column: name,
			index: index,
			id: value,
			name: itemName
		};
		this.props.changeContract(changeItem);
	}
	toggleEditContract(index) {
		if (this.props.employeeManagement.contractDetail[index].unedit) {
			let deepCopyContract = JSON.parse(JSON.stringify(this.props.employeeManagement.contractDetail[index]));
			deepCopyContract.unedit = true;
			let copyState = { ...this.state.editingContract };
			copyState[index] = deepCopyContract;
			this.setState({editingContract: copyState});
			this.props.toggleEditContract(index);
		}else{
			this.props.recoverContract(index, this.state.editingContract[index]);
		}
	}
	render() {
		return (
			<div className="app-module-item">
				<div className="colAction">
					<Button type="primary" onClick={() => window.history.go(-1)}>

							<Icon type="arrow-left" />
							<span>返回</span>

					</Button>
					<Divider type="vertical" />
					<Button type="primary" onClick={this.newContract.bind(this)}>
						<Icon type="plus" />
						<span>新增合同</span>
					</Button>
				</div>
				<div style={{textAlign:"center"}}>
				{ this.props.employeeManagement.contractDetailStatus ?
					<div>
						<Row style={{marginBottom:"40px"}}>
							<h2>合同记录详情</h2>
							<Col span={12} style={{marginBottom:"20px"}}>
								<span>部门 : </span>
								<span>{this.props.employeeManagement.contractUserDetail.department_name}</span>
							</Col>
							<Col span={12} style={{marginBottom:"20px"}}>
								<span>姓名 : </span>
								<span>{this.props.employeeManagement.contractUserDetail.real_name}</span>
							</Col>
							<Col span={12} style={{marginBottom:"20px"}}>
								<span>工号 : </span>
								<span>{this.props.employeeManagement.contractUserDetail.id_number}</span>
							</Col>
							<Col span={12} style={{marginBottom:"20px"}}>
								<span>证件号 : </span>
								<span>{this.props.employeeManagement.contractUserDetail.job_number}</span>
							</Col>
						</Row>
						{ this.props.employeeManagement.contractDetail.map((detail, index) => {
							return (<Row key={index} style={{marginBottom:"40px"}}>
							<Col span={6}></Col>
							<Col span={12}>
								<h2 style={{margin:"0px 5px 20px 5px"}}>合同记录{index + 1}</h2>
							</Col>
							<Col span={6}>
								{ detail.unedit ?
								<span onClick={this.toggleEditContract.bind(this, index)}>
									<Button icon="edit" size="small" className="row-action-btn">编辑</Button>
								</span> :
								<span>
									<span onClick={this.addContract.bind(this, index)}>
										<Button icon="save" size="small" className="row-action-btn">保存</Button>
									</span>
									{ !detail.unsave &&
									<span onClick={this.toggleEditContract.bind(this, index)}>
										<Button icon="close" size="small" className="row-action-btn">取消</Button>
									</span>
									}
								</span>
								}
								{ (detail.unsave || !detail.is_active) &&
								<span onClick={this.deleteContract.bind(this, index)}>
									<Button icon="delete" size="small" className="row-action-btn">删除</Button>
								</span>}
							</Col>						
							<Col span={12} style={{marginBottom:"20px",height:"32px"}}>
								<label>合同属性 : </label>
								{detail.unedit ? 
									<span>{detail.property_name}</span>
									:
									<Select value={detail.property_id} style={{width:"172px"}} 
										onChange={this.changeContract.bind(this, 'contract_properties', index)}>
										<Select.Option key={detail.property_id} value={detail.property_id}>
											{detail.property_name}
										</Select.Option>
										{this.props.employeeManagement.contract_properties.map(property => {
											if (property.Text !== detail.property_name) {
												return (<Select.Option key={property.Value} value={property.Value}>{property.Text}</Select.Option>)
											}
											return false;
										})}
									</Select>
								}
							</Col>
              {!detail.new &&
							<Col span={12} style={{marginBottom:"20px",height:"32px"}}>
								<span>合同状态 : </span>
								{detail.unedit ? 
									<span>{detail.status_name}</span>
									:
									<Select value={detail.status_id} style={{width:"172px"}}
										onChange={this.changeContract.bind(this, 'contract_statuses', index)}>
										<Select.Option key={detail.status_id} value={detail.status_id}>
											{detail.status_name}
										</Select.Option>
										{this.props.employeeManagement.contract_statuses.map(status => {
											if (status.Text !== detail.status_name) {
												return (<Select.Option key={status.Value} value={status.Value}>{status.Text}</Select.Option>)
											}
											return false;
										})}
									</Select>
								}
							</Col>
              }
							<Col span={12} style={{marginBottom:"20px",height:"32px"}}>
								<span>合同开始时间 : </span>
								{detail.unedit ? 
									<span>{detail.start_date}</span>
									:
									<DatePicker value={detail.start_date ? moment(detail.start_date) : null}
										onChange={this.changeContract.bind(this, 'start_date', index)} />
								}
							</Col>
							<Col span={12} style={{marginBottom:"20px",height:"32px"}}>
								<span>合同类型 : </span>
								{detail.unedit ? 
									<span>{detail.type_name}</span>
									:
									<Select value={detail.type_id} style={{width:"172px"}}
										onChange={this.changeContract.bind(this, 'contract_types', index)}>
										<Select.Option key={detail.type_id} value={detail.type_id}>
											{detail.type_name}
										</Select.Option>
										{this.props.employeeManagement.contract_types.map(type => {
											if (type.Text !== detail.type_name) {
												return (<Select.Option key={type.Value} value={type.Value}>{type.Text}</Select.Option>)
											}
											return false;
										})}
									</Select>
								}
							</Col>
							<Col span={12} style={{marginBottom:"20px",height:"32px"}}>
								<span>合同截至时间 : </span>
								{detail.unedit ? 
									<span>{detail.end_date}</span>
									:
									<DatePicker value={detail.end_date ? moment(detail.end_date) : null}
										onChange={this.changeContract.bind(this, 'end_date', index)} />
								}
							</Col>
              {!detail.new &&
							<Col span={12} style={{marginBottom:"20px",height:"32px"}}>
								<span>试用期截至时间 : </span>
								{detail.unedit ?
									<span>{detail.probation_end_date}</span>
									:
									<DatePicker value={detail.probation_end_date ? moment(detail.probation_end_date) : null}
										onChange={this.changeContract.bind(this, 'probation_end_date', index)} />
								}
							</Col>
              }
						</Row>)
						})}
					</div>
				: <div style={{textAlign:'center', margin: '100px 0px'}}><Spin size="large" /></div>}
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		routing: state.routing,
		employeeManagement: state.employeeManagement
	}
}

const mapDispatchToProps = {
	fetchContractDetail,
	toggleEditContract,
	newContract,
	deleteContract,
	addContract,
	changeContract,
	editContract,
	recoverContract
}

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(ContractManagementDetail));


// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/ContractManagementDetail.js